import { Flex, Link as StyleLink} from '@chakra-ui/react'
import { Link } from 'react-router-dom';
import { MdArrowBack as LeftArrowIcon } from "react-icons/md";

const sx = {
    display:"flex",
    alignItems:'center',
    gap:'10px',
    cursor:'pointer',
    textDecoration:'none'
}

const TopLink = () => {
  return (
    <Flex textDecorationLine={"none"}>
        <StyleLink sx={sx} textDecoration={'none'} as={Link} to="/settings"><LeftArrowIcon />Settings
        </StyleLink>
      </Flex>
  )
}

export default TopLink